import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import LoaderButton from '../../../shared/components/Button/LoaderButton';
import './IAQChartSettingForm.css';

import { FormattedMessage } from 'react-intl';
//import { getDateRangeSelector, getSensorSelector } from '../../../core/selectors/sensor.selector';
import DateTimeWidget from "../../../shared/components/DateTimeWidget/DateWidget";
import { formatMessage } from '../../../translations/connectedIntlProvider';
import { validateRequired } from '../../../helpers/validation.helper';

interface IProps {
    EndDate?: string;
    range?: string;
    isTillDate?: boolean;
    submitHandler: (data: any) => void;
    onModalClosed: () => void;
}

const IAQChartSettingForm: React.FC<InjectedFormProps<any, IProps> & IProps> = (props: any) => {
    // console.log("Eqbal:");
    // console.log(props.isTillDate);
    const [range, setRange] = useState<any>(props.range);
    const [endDateDisabled, setEndDateDisabled] = useState(props.isTillDate);
    const handleChange = (event: any) => {
        setRange(event.target.value);
    }

    const chkOnChange = (event: any) => {
        // console.log(event.target.checked);
        setEndDateDisabled(event.target.checked);
    }

    return (
        <Modal className="add-user-modal device-pop-up" show={true} centered onHide={props.onModalClosed}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <FormattedMessage id='Data_Range' />
                </Modal.Title>
            </Modal.Header>

            <form onSubmit={props.handleSubmit((values: any) => props.submitHandler({ EndDate: values.EndDate, range: range ? range : "1", isTillDate: endDateDisabled }))} noValidate>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="label-style"><FormattedMessage id='Duration' /></label>
                                <select value={range} onChange={handleChange}>
                                    <option value="1">{formatMessage("1_Day")}</option>
                                    <option value="7">{formatMessage("1_Week")}</option>
                                    <option value="30">{formatMessage("1_Month_avg")}</option>
                                    {/* <option value="90">{formatMessage("3_Months")}</option>
                                    <option value="180">{formatMessage("6_Months")}</option>
                                    <option value="365">{formatMessage("1_Year")}</option> */}
                                </select>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <div className="row">
                                    <div className="col-6">
                                        <label className="label-style" style={{ width: 'auto' }}><FormattedMessage id='End_Date' /></label>
                                    </div>
                                    <div className="col-6 pl-0">
                                    <div className="form-group checkbox">
                                        <div className="checkbox-area d-table">
                                            <div className="float-right mt-1">
                                                <label>
                                                    <input id="isTillDate" onChange={chkOnChange} type="checkbox" value={props.isTillDate} defaultChecked={endDateDisabled} />
                                                    <span className="cr">
                                                        <i className="cr-icon fas fa-check"></i>
                                                    </span>
                                                </label>
                                                <p><FormattedMessage id='End_Date_Till_Date' /></p>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <Field
                                    disabled={endDateDisabled}
                                    className="form-control"
                                    name="EndDate"
                                    EndDate={props.EndDate}
                                    component={DateTimeWidget}
                                    validate={[validateRequired("Validation_Required_EndDate")]
                                    }
                                />
                            </div>
                        </div>
                    </div>

                </Modal.Body>

                <div className="modal-footer">
                    <div className="form-group row tab-action">
                        <div className="col-12 px-0">
                            <Button variant="primary" onClick={props.onModalClosed}><FormattedMessage id='Button_Cancel' /></Button>
                            <LoaderButton type="submit" text="Button_Save" />
                        </div>
                    </div>
                </div>
            </form>

        </Modal>
    )
}

const form = reduxForm<any, IProps>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
    form: 'IAQChartSettingForm',
    enableReinitialize: true,
    onSubmitFail: (errors: any) => {
    }
})(IAQChartSettingForm);


export default (form);
